import { Injectable } from '@angular/core';
import { FormControl, ValidationErrors } from '@angular/forms';

@Injectable()
export class UtilService {

  public isCnpjInvalid(cnpjValue: string, invalidCnpjFormat: boolean) {
    const cnpjLength = cnpjValue?.length || 0;
    return cnpjLength > 3 && invalidCnpjFormat;
  }
  public isCPFInvalid(cpfValue: string, invalidCpf: boolean) {
    const cpfLength = cpfValue?.length || 0;
    return cpfLength > 3 && invalidCpf;
  }

  public cnpjValidator(control: FormControl): ValidationErrors | null {
    const cnpj = control.value?.replace(/\D/g, '');
    if (!cnpj || !/^\d{14}$/.test(cnpj)) {
      return { invalidCnpjFormat: true };
    }
  
    const invalidValues = [
      '00000000000000',
      '11111111111111',
      '22222222222222',
      '33333333333333',
      '44444444444444',
      '55555555555555',
      '66666666666666',
      '77777777777777',
      '88888888888888',
      '99999999999999',
    ];
  
    if (invalidValues.includes(cnpj)) {
      return { invalidCnpj: true };
    }
  
    let sum = 0;
    let weight = 2;
    for (let i = 11; i >= 0; i--, weight = weight === 9 ? 2 : weight + 1) {
      sum += parseInt(cnpj.charAt(i)) * weight;
    }
  
    const dv1 = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  
    sum = 0;
    weight = 2;
  
    for (let i = 12; i >= 0; i--, weight = weight === 9 ? 2 : weight + 1) {
      sum += parseInt(cnpj.charAt(i)) * weight;
    }
  
    const dv2 = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  
    if (
      dv1 !== parseInt(cnpj.charAt(12)) ||
      dv2 !== parseInt(cnpj.charAt(13))
    ) {
      return { invalidCnpj: true };
    }
  
    return null;
  }
  

  public cpfValidator(control: FormControl): { [key: string]: boolean } | null {
    const cpf = control.value.replace(/[^\d]/g, ''); // remove caracteres não numéricos
  
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
      return { 'invalidCpf': true }; // CPF inválido
    }
  
    let sum = 0;
    let remainder;
  
    for (let i = 1; i <= 9; i++) {
      sum += parseInt(cpf[i - 1]) * (11 - i);
    }
  
    remainder = (sum * 10) % 11;
  
    if ((remainder === 10) || (remainder === 11)) {
      remainder = 0;
    }
  
    if (remainder !== parseInt(cpf[9])) {
      return { 'invalidCpf': true }; // CPF inválido
    }
  
    sum = 0;
  
    for (let i = 1; i <= 10; i++) {
      sum += parseInt(cpf[i - 1]) * (12 - i);
    }
  
    remainder = (sum * 10) % 11;
  
    if ((remainder === 10) || (remainder === 11)) {
      remainder = 0;
    }
  
    if (remainder !== parseInt(cpf[10])) {
      return { 'invalidCpf': true }; // CPF inválido
    }
  
    return null; // CPF válido
  }

  cepValidator(control: FormControl): ValidationErrors | null {
    const cepRegex = /^[0-9]{5}-?[0-9]{3}$/; // Expressão regular para validar CEP
    const cep = control.value;

    if (!cepRegex.test(cep)) {
      return {'invalidCEP': {value: cep}}; // Retorna objeto com chave 'invalidCEP' e valor do CEP inválido
    }

    return null; // Retorna nulo caso o CEP seja válido
  }

  getLocale() {
    const language = localStorage.getItem('language');
    switch (language) {
      case 'pt':
        return 'pt-BR';
      case 'en':
        return 'en-US'
      case 'es':
        return 'es-ES'
      default: return 'pt-BR';
    }
  }
}
